/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PointsInFlensburg } from './pointsInFlensburg';
import { OccupationBranche } from './occupationBranche';
import { PartnerRelationship } from './partnerRelationship';
import { BankDetails } from './bankDetails';
import { HomeOwnership } from './homeOwnership';
import { PartnerAddress } from './partnerAddress';
import { Contact } from './contact';
import { LegalStructure } from './legalStructure';

/**
 * Represents a sole proprietorship (german: Einzelunternehmung) or company.   (german: juristische Person)   (bipro-partner::JuristischePerson)
 */
export interface LegalPerson {
  /**
   * Technical discriminator for the concrete partner type..  Value must be one of the sub classes *Person*, *LegalPerson*.
   */
  partnerType: string;
  /**
   * Unique identification of a partner within the scope of the request/response object.   Every partner object must define a partner ID.   Every partner role may reference a corresponding partner object.   Values can be choosen freely, but must be unique in the request/response object.
   */
  partnerId: string;
  /**
   * Communication details like email, phone, etc..   (bipro-partner::Kommunikationsverbindung)
   */
  contacts?: Array<Contact>;
  /**
   * Partner may have one or more addresses.   (bipro-partner::Partneranschrift)
   */
  partnerAddresses?: Array<PartnerAddress>;
  /**
   * Partner may have one or more bank details.   (bipro-partner::Bankverbindung)
   */
  bankDetails?: Array<BankDetails>;
  homeOwnership?: HomeOwnership;
  pointsInFlensburg?: PointsInFlensburg;
  /**
   * Safety training for motor vehicles.   (german: Sicherheitstraining)   (bipro-versicherung-kraftfahrt::PartnerdatenKfz)
   */
  safetyTraining?: boolean;
  /**
   * Relationship of other partners, according to this partner. Example: In case of relationship kind *Child*, the related partner is the child of this partner.   (bipro-partner::Partnerbeziehung)
   */
  partnerRelationships?: Array<PartnerRelationship>;
  /**
   * Whether this partner is eligible for input tax deduction.   (german: Vorsteuerabzug)   (bipro-partner::Vorsteuerabzugsberechtigt)
   */
  inputTaxDeduction?: boolean;
  companyName?: string;
  legalStructure?: LegalStructure;
  branche?: OccupationBranche;
  /**
   * VAT ID of the legal person.   First two characters are the country code according to ISO-3166-1 Alpha 2.   (german: Umsatzsteuer-ID)
   */
  vatID?: string;
  /**
   * Full name of the authorized representative.   (german: Vertretungsberechtigter)
   */
  authorizedRepresentative?: string;
}
export namespace LegalPerson {}
